import store from '../store/store';
import { sportsApiUrl } from './apiUrls';

let userId = null;
let token = null;
let clientId = null;

store.subscribe(state => {
    userId = state.user.id;
    token = state.user.token;
    clientId = state.user.selectedClientId;
});

const env = __PROD_API__ ? 'production' : 'development';

const getUrl = (env, type) => {
    switch (env) {
        case 'localhost':
            return `http://localhost:5000/${type}`;

        default:
            return `${sportsApiUrl}/report-renderer/${type}`;
    }
};

const getCurrentVideoFrame = async ({ videoUrl, offset }) => {
    const url = getUrl(env, `extract-frame/?url=${videoUrl}&offset=${offset}`);
    const fetchRes = await fetch(url, {
        method: 'get',
        headers: {
            'api-consumer-key': 'mvc',
            'x-auth-token': token,
            'x-auth-user-id': userId,
            'x-client-id': clientId,
        },
    });
    const { frame_url } = await fetchRes.json();
    return frame_url;
};

export default getCurrentVideoFrame;
